<template>
    <div>
        <template v-if="row.item.invoice_type === 'outgoing' && checkActionAllow('only_incoming_operations')">
            Операции отсутствуют
        </template>
        <template v-else>
            <b-button-group size="sm" class="w-100 table-actions">
                <b-button
                    variant="table"
                    v-if="checkActionAllow('show')"
                    @click="showItem(row.index)"
                >
                    <i class="far fa-eye"></i>
                </b-button>
                <b-button
                    variant="table"
                    v-if="(checkActionAllow('edit') && checkIfNoDebt()) || currentUser.role.includes('administrator')"
                    @click="createOrEditItemModal(row.index)"
                >
                    <i class="fas fa-pencil-alt"></i>
                </b-button>
                <b-button
                    variant="table"
                    v-if="checkActionAllow('delete') && (checkIfNoDebt() || currentUser.role.includes('administrator'))"
                    @click="deleteItem(row.index)"
                >
                    <i class="fas fa-trash text-danger"></i>
                </b-button>
            </b-button-group>
            <div class="mt-1">
                <span
                    v-if="checkActionAllow('create_request') && row.item.draft == 0"
                    class="mt-2 action-chip pl-1 pr-1"
                    @click="askFinanceOperation(row.index)"
                >
                    <span class="action-chip__label">Запрос&nbsp;бухгалтеру</span>
                </span>
                <span v-if="row.item.draft == 1">
                    <small>Это драфт счёта</small>
                </span>
            </div>            
        </template>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import {
        checkActionAllow
    } from '@/mixins'

    export default {
        props: {
            row: {type: Object, required: true},                                                // Row of table
            actionAllows: {type: Array, required: false, default: function () { return [] }},   // Array of rules for action allows
        },
        mixins: [
            checkActionAllow
        ],
        computed: {
            ...mapGetters('auth', ['currentUser'])
        },
        methods: {
            showItem(index) {
                this.$emit('universalEmit', 'show', index, '', 'finance')
            },
            createOrEditItemModal(index) {
                this.$emit('universalEmit', 'edit', index)
            },
            deleteItem(index) {
                this.$emit('universalEmit', 'delete', index)
            },
            askFinanceOperation(index) {
                this.$emit('universalEmit', 'askFinanceOperation', index)
            },
            checkIfNoDebt() {
                if(this.row.item.sum_payment == 0) {
                    return true
                }
                return false
            },
        }
    }
</script>

